import { render } from "./StandingRow.vue?vue&type=template&id=15fe8c25"
import script from "./StandingRow.vue?vue&type=script&lang=js"
export * from "./StandingRow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__